import { msg } from '@lingui/core/macro';
import { z } from 'zod';

// Abas por `?tab=` com os ids do `href` do legado (VortxContainer.tsx:5-11, S29); a primeira não vai
// para a URL. O envio do arquivo abre por `?sheet=` (U26: o voltar fecha).
export const RECONCILIATION_PATH = '/concilicao';
export const RECONCILIATION_TAB_IDS = ['fgts', 'siape', 'gerar-arquivo-liquidacao-caixa', 'calcular-liquidacao-antecipada'] as const;
export type ReconciliationTab = (typeof RECONCILIATION_TAB_IDS)[number];
export const RECONCILIATION_TABS = [
  { id: 'fgts', label: msg`Conciliação Caixa`, icon: 'landmark' },
  { id: 'siape', label: msg`Conciliação SIAPE`, icon: 'building-2' },
  { id: 'gerar-arquivo-liquidacao-caixa', label: msg`Relatórios de Conciliação`, icon: 'file-text' },
  { id: 'calcular-liquidacao-antecipada', label: msg`Liquidação Antecipada`, icon: 'wallet' },
] as const;
export const RECONCILIATION_SHEETS = ['caixa', 'siape'] as const;
export type ReconciliationSheet = (typeof RECONCILIATION_SHEETS)[number];

export const reconciliationSearch = z.object({
  tab: z.enum(RECONCILIATION_TAB_IDS).optional().catch(undefined),
  sheet: z.enum(RECONCILIATION_SHEETS).optional().catch(undefined),
});
export type ReconciliationSearch = z.infer<typeof reconciliationSearch>;

/** Caminhos antigos (router.tsx:789-823) → aba da tela nova (S28/S29). */
export const LEGACY_TAB_REDIRECTS: Readonly<Record<string, ReconciliationTab>> = {
  '/concilicao/fgts': 'fgts',
  '/concilicao/fgts/siape': 'siape',
  '/concilicao/fgts/gerar-arquivo-liquidacao-caixa': 'gerar-arquivo-liquidacao-caixa',
  '/concilicao/fgts/calcular-liquidacao-antecipada': 'calcular-liquidacao-antecipada',
};

/** Busca da aba: a primeira não vai para a URL. */
export function tabSearch(tab: ReconciliationTab): ReconciliationSearch {
  return tab === 'fgts' ? {} : { tab };
}
